module.exports = __webpack_public_path__ + "static/media/icon_caalender_right.1340672a.svg";